<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Col, Radio, Row, Text } from '@Shelly/shelly-design-system';
	import { unitOptions } from 'src/stores/account/home';

	export let selectedUnitId: string;
	export let selectedCount: number = 1;
	export let idPrefix: string = 'move-unit';
	export let infoTextKey: string = 'settings_move_select_unit_info';
	export let infoTextDefault: string = 'Move {count} device(s) to:';
</script>

<Text styleType="body-small" class="mb-m">
	{$format(infoTextKey, {
		default: infoTextDefault,
		values: { count: selectedCount },
	})}
</Text>

{#each $unitOptions as unit}
	<Row class="mb-s">
		<Col sm="10" md="11" lg="11">
			<Radio
				size="m"
				id="{idPrefix}-{unit.value}"
				value={unit.value}
				selected={selectedUnitId}
				on:click={() => (selectedUnitId = unit.value)}>{unit.title}</Radio
			>
		</Col>
	</Row>
{/each}
